import Vue from 'vue';
import { Component, Prop, Watch } from 'vue-property-decorator';
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";
import { durchsatz, graphData } from '../content/content.model';

am4core.useTheme(am4themes_animated);

@Component(
    {
        name: 'barchart',
    }
)
export default class ColumnChartComponent extends Vue {
    @Prop({ required: true })
    chartData!: graphData<durchsatz>;

    name: string = "";
    id: string = "";
    chart: any;

    mounted() {
        this.id = "chartDiv_column";
    }

    updated() {
        this.name = this.chartData.name!;
        this.generateChart();
    }

    beforeDestroy() {
        if (this.chart)
            this.chart.dispose();
    }

    @Watch('chartData')
    onDataUpdate() {
        this.$forceUpdate();
    }

    generateChart() {
        if (this.chart)
            this.chart.dispose();

        // Create chart
        this.chart = am4core.create(this.id, am4charts.XYChart);
        //"lineColor": chart.colors.next()
        this.chart.data = this.chartData.data;

        // Create axes
        var categoryAxis = this.chart.xAxes.push(new am4charts.DateAxis());
        categoryAxis.renderer.grid.template.location = 0;
        categoryAxis.renderer.minGridDistance = 30;
        categoryAxis.renderer.labels.template.horizontalCenter = "right";
        categoryAxis.renderer.labels.template.verticalCenter = "middle";
        //categoryAxis.renderer.labels.template.rotation = 270;
        if (categoryAxis.tooltip)
            categoryAxis.tooltip.disabled = true;
        categoryAxis.renderer.minHeight = 25;
        categoryAxis.baseInterval = {
            timeUnit: "hour",
            count: 1
        };

        var valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
        valueAxis.renderer.minWidth = 25;

        // Create series
        var series = this.chart.series.push(new am4charts.ColumnSeries());
        series.sequencedInterpolation = true;
        series.dataFields.dateX = "time";
        series.dataFields.valueY = "value";
        series.tooltipText = "{description}";
        series.columns.template.strokeWidth = 0;

        if (series.tooltip)
            series.tooltip.pointerOrientation = "vertical";

        series.columns.template.column.cornerRadiusTopLeft = 10;
        series.columns.template.column.cornerRadiusTopRight = 10;
        series.columns.template.column.fillOpacity = 0.8;

        // on hover, make corner radiuses bigger
        var hoverState = series.columns.template.column.states.create("hover");
        hoverState.properties.cornerRadiusTopLeft = 0;
        hoverState.properties.cornerRadiusTopRight = 0;
        hoverState.properties.fillOpacity = 1;

        series.columns.template.adapter.add("fill", (fill, target) => {
            return this.chart.colors.getIndex(target?.dataItem?.index ?? 0);
        });

        // Cursor
        this.chart.cursor = new am4charts.XYCursor();

    }
}